import React from 'react'
import WizardTopMenu from './WizardLayout/WizardTopMenu'

const Wizard = () => {
  return (
    <div>
      <WizardTopMenu/>
    </div>
  )
}

export default Wizard
